import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ThrowErrorPage = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get("token");
  const tokenMatch = token === "fs4sd!3D28fs";

  useEffect(() => {
    if (tokenMatch) {
      throw new Error(
        "This is an unhandled client test error for Sentry testing"
      );
    }
  }, [token]);

  return <div>This page throws an unhandled test error for Sentry testing</div>;
};

export default ThrowErrorPage;
